import { render } from "./AllTeams.vue?vue&type=template&id=d116d85e"
import script from "./AllTeams.vue?vue&type=script&lang=js"
export * from "./AllTeams.vue?vue&type=script&lang=js"
script.render = render

export default script